<lh-shared-ui-spinner *ngIf="isLoading"></lh-shared-ui-spinner>

<div *ngIf="booking" class="info-header">
  <div class="container-fluid lh-container-fluid-sm">
    <div class="flex">
      <!-- <h1 class="heading-5">{{ booking.shopName }}</h1> -->
      <h1 class="heading-5">{{ 'BOOKING_DETAILS' | translate }}</h1>

      <div class="info-buttons">
        <div *ngIf="strategy.showDirections">
          <!-- <span>{{ booking.address.street }}&nbsp;</span> -->
          <span>{{ booking.shopName }}&nbsp;</span>

          <button (click)="directionsModal.show()" class="btn btn-info btn-sm">
            {{ 'FIND_SHOP' | translate }}
          </button>

          <!-- <a type="button" class="btn btn-info btn-sm" [href]="shop | mapsLink: true" target="_blank" angulartics2On="click" 
              angularticsAction="ViewGoogleMapsBooking" [angularticsCategory]="booking.address.countryCode" [angularticsLabel]="booking.shopName">
              {{ 'GET_DIRECTIONS' | translate }}
            </a> -->
        </div>

        <span *ngIf="!strategy.showDirections">
          <span *ngIf="strategy.isCanceledSectionVisible">{{ 'BOOKING_PROGRESS_CANCELED' | translate }}</span>
          <span *ngIf="!strategy.isCanceledSectionVisible">{{ 'DIRECTIONS_AFTER_PAYMENT_INFO' | translate }}</span>
        </span>
      </div>
    </div>
  </div>
</div>

<!--Sections-->
<div *ngIf="booking" class="container-fluid lh-container-fluid-sm main-container">
  <!--Storage timer-->
  <div *ngIf="booking.status !== 'CONFIRMED'">
    <div class="storage-timer">
      <span *ngIf="storageTimerDays > 0">{{ ('0' + storageTimerDays).slice(-2) }}</span>
      <span *ngIf="storageTimerDays > 0">{{ 'STORAGE_TIMER_DAYS' | translate }}</span>
      <span>{{ ('0' + storageTimerHours).slice(-2) }}</span>
      <span>{{ 'STORAGE_TIMER_HOURS' | translate }}</span>
      <span>{{ ('0' + storageTimerMinutes).slice(-2) }}</span>
      <span>{{ 'STORAGE_TIMER_MINUTES' | translate }}</span>
      <span>{{ ('0' + storageTimerSeconds).slice(-2) }}</span>
      <span>{{ 'STORAGE_TIMER_SECONDS' | translate }}</span>
    </div>
    <label class="storage-title label-sm">{{ 'STORAGE_TIMER' | translate }}</label>
  </div>

  <div *ngIf="booking.status === 'CONFIRMED'">
    <!-- <div class="form-group text-center">
      <small>{{ 'ADDRESS' | translate }}</small>
      <strong>{{ booking.address.street }}</strong>
    </div> -->

    <div class="form-group">
      <strong
        ><span class="security-highlight">{{ 'SECURE_YOUR_BAGS' | translate }}</span></strong
      >
      {{ 'WITH_THE_SEALS_PROVIDED' | translate }}:
    </div>

    <!-- Security seal explanation -->
    <div class="form-group text-center">
      <!-- <img class="luggage-tag-img" src="../../../../assets/luggage-tag.png"> -->
      <img class="luggage-tag-img" src="https://media.giphy.com/media/xUNd9DQptvUmE5BSmI/giphy.gif" />
      <small
        >{{ insuranceCoverage | price: booking.price.pricing.currency : 2 : true }} {{ 'COVERAGE' | translate }}
        {{ 'PER_BAG' | translate | lowercase }}</small
      >
    </div>

    <!-- <hr> -->
  </div>

  <div class="list-group">
    <!--Feedback section-->
    <div
      *ngIf="strategy.isFeedbackSectionVisible"
      (click)="showFeedback()"
      [class.active]="activeSection === 'feedback'"
      [class.completed]="strategy.isFeedbackSectionCompleted"
    >
      <div class="list-group-item feedback-section">
        <span class="success-icon">
          <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
        </span>

        <div *ngIf="!strategy.isFeedbackSectionCompleted">
          <div>{{ 'FEEDBACK' | translate }}</div>
          <small>{{ 'YOUR_FEEDBACK_IS_IMPORTANT' | translate }}</small>
        </div>

        <div *ngIf="strategy.isFeedbackSectionCompleted">
          <div>{{ 'FEEDBACK' | translate }}</div>
          <small>{{ 'FEEDBACK_RECEIVED' | translate }}</small>
        </div>
      </div>
    </div>

    <!--Canceled section-->
    <div *ngIf="strategy.isCanceledSectionVisible" [class.completed]="strategy.isCanceledSectionCompleted">
      <div class="list-group-item cancel-section">
        <span class="success-icon">
          <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
        </span>
        <div>
          <div>{{ 'BOOKING_PROGRESS_CANCELED' | translate }}</div>
          <small>{{ 'BOOKING_PROGRESS_CANCELED_SUBTEXT' | translate }}</small>
        </div>
      </div>
    </div>

    <!--Check out section-->
    <div
      *ngIf="strategy.isCheckOutSectionVisible"
      (click)="showCheckOut()"
      [class.active]="activeSection === 'checkOut'"
      [class.completed]="strategy.isCheckOutSectionCompleted"
      [class.highlighted]="strategy.isCheckOutSectionHighlighted"
    >
      <div
        class="list-group-item checkout-section"
        [class.error]="strategy.isCheckOutSectionFailed"
        [class.warning]="strategy.isCheckOutSectionWarning"
      >
        <span class="success-icon">
          <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
        </span>

        <div *ngIf="!isBookingCheckedOut">
          <div>{{ 'PICK_UP' | translate }}</div>
          <small>{{ 'READY_TO_COLLECT' | translate }}</small>
        </div>

        <div *ngIf="isBookingCheckedOut">
          <!--Payment succeeded-->
          <div *ngIf="booking.status === 'PAID'">
            <!-- Payment via LuggageHero -->
            <div *ngIf="!isDirectPaymentSelected">
              <div>{{ 'BOOKING_PROGRESS_CHECKED_OUT' | translate }}</div>
              <small
                >{{ booking.price.final.total | price: booking.price.final.currency : 2 : true }}
                {{ 'PAID' | translate }} {{ booking.period.checkOut | lhMoment: 'localeDateTime' }}</small
              >
            </div>

            <!-- Payment in shop -->
            <div *ngIf="isDirectPaymentSelected">
              <div>{{ 'PAY_THE_STAFF' | translate }}</div>
              <small
                >{{ 'FINAL_PRICE' | translate }}:
                {{ booking.price.final.total | price: booking.price.final.currency : 2 : true }}</small
              >
            </div>
          </div>

          <!--Payment failed-->
          <div *ngIf="booking.status === 'CHECKED_OUT'">
            <div>{{ 'BOOKING_PROGRESS_CHECKED_OUT' | translate }} ({{ 'PAYMENT_FAILED' | translate | lowercase }})</div>
            <small
              >{{ booking.price.final.total | price: booking.price.final.currency : 2 : true }}
              {{ 'COULD_NOT_BE_CHARGED' | translate }}</small
            >
          </div>
        </div>
      </div>
    </div>

    <!--Check in section-->
    <div
      *ngIf="strategy.isCheckInSectionVisible"
      (click)="showCheckIn()"
      [class.active]="activeSection === 'checkIn'"
      [class.completed]="strategy.isCheckInSectionCompleted"
      [class.highlighted]="strategy.isCheckInSectionHighlighted"
    >
      <div class="list-group-item checkin-section">
        <span class="success-icon">
          <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
        </span>

        <div *ngIf="!strategy.isCheckOutSectionVisible">
          <div>{{ 'DROP_OFF' | translate }}</div>
          <small>{{ 'READY_TO_HAND_IN' | translate }}</small>
        </div>

        <div *ngIf="strategy.isCheckOutSectionVisible">
          <div>{{ 'BOOKING_PROGRESS_CHECKED_IN' | translate }}</div>
          <small
            >{{ luggageSummary }} {{ 'CHECKED_IN' | translate }}
            {{ booking.period.checkIn | lhMoment: 'localeDateTime' }}</small
          >
        </div>
      </div>
    </div>

    <!--Payment method section-->
    <div
      *ngIf="strategy.isPaymentMethodSectionVisible"
      (click)="showPaymentMethod()"
      [class.active]="activeSection === 'paymentMethod'"
      [class.completed]="strategy.isPaymentMethodSectionCompleted"
    >
      <div class="list-group-item payment-section">
        <span class="success-icon">
          <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
        </span>

        <!-- <div *ngIf="!paymentMethod">{{ 'CHECK_IN' | translate}}</div> -->

        <div *ngIf="!strategy.isPaymentMethodSectionCompleted">
          <div *ngIf="activeSection !== 'paymentMethod'">
            <strong>{{ 'NO_PAYMENT_METHOD_SELECTED' | translate }}</strong>
            <small>{{ 'ADD_PAYMENT_INFO_NOW' | translate }}</small>
          </div>
          <div *ngIf="activeSection === 'paymentMethod'">
            <strong>{{ 'SELECT_PAYMENT_METHOD' | translate }}</strong>
          </div>
        </div>

        <div *ngIf="strategy.isPaymentMethodSectionCompleted">
          <div>{{ 'PAYMENT_METHOD_SELECTED' | translate }}</div>
          <small *ngIf="!isDirectPaymentSelected">{{ paymentMethod | paymentMethod: 'summary' }}</small>
          <small *ngIf="isDirectPaymentSelected">{{ 'PAYING_IN_THE_SHOP' | translate }}</small>
        </div>
      </div>
    </div>

    <!--Reservation section-->
    <div *ngIf="strategy.isReservationSectionVisible" (click)="showReservation()" class="completed">
      <div class="list-group-item booking-section">
        <span class="success-icon">
          <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
        </span>
        <div>
          <div>
            <span *ngIf="shop && shop.address">{{ shop.name }}</span>
          </div>

          <small>
            {{ 'SPACE_RESERVED_FOR' | translate }} {{ booking.luggage.normal + booking.luggage.hand }}
            {{ (booking.luggage.normal + booking.luggage.hand === 1 ? 'BAG' : 'BAGS') | translate }}
            {{ booking.period.from | lhMoment: 'calendar' }}
          </small>
        </div>
      </div>
    </div>
  </div>

  <!--Cancel button-->
  <lh-cancel-booking [(booking)]="booking"></lh-cancel-booking>

  <!-- <div *ngIf="!booking.paymentMethodId" class="text-center">
    <small><strong class="text-warning">NOTE:</strong> {{ 'NO_PAYMENT_METHOD_SELECTED' | translate }}</small><br>
  </div> -->

  <div *ngIf="shop && shop.address" class="text-center">
    <!-- <div class="form-group"><strong class="address-highlight">{{ 'ADDRESS' | translate }}:</strong> {{ shop.address.street }}</div> -->

    <!-- <div class="form-group">
      <a *ngIf="strategy.showDirections" class="btn btn-info btn-md btn-block" [href]="shop | mapsLink: true" target="_blank" angulartics2On="click" 
        angularticsAction="ViewGoogleMapsBooking" [angularticsCategory]="booking.address.countryCode" [angularticsLabel]="booking.shopName">
        {{ 'GET_DIRECTIONS' | translate }}
      </a>
    </div> -->
  </div>

  <!--Discount code button-->
  <!-- <a *ngIf="booking.status === 'CONFIRMED' || booking.status === 'CHECKED_IN'" type="button" (click)="paymentMethodModal.show()" class="discount-btn href">
    <span *ngIf="!booking.price.discountCode || booking.price.estimated.discount === 0">{{ 'HAVE_A_DISCOUNT_CODE' | translate}}</span>
    <span *ngIf="booking.price.discountCode && booking.price.estimated.discount > 0">✔ {{ 'DISCOUNT_CODE_APPLIED' | translate}}</span>
  </a> -->

  <!-- Tutorial button -->
  <!-- <a *ngIf="booking.status === 'CONFIRMED' || booking.status === 'CHECKED_IN'" type="button" (click)="tutorialModal.show()" class="discount-btn href">
    <span>{{ 'HOW_IT_WORKS' | translate}}</span>
  </a> -->
</div>

<!--Feedback modal-->
<div
  *ngIf="booking"
  class="modal fade"
  [class.modal-ios]="ios"
  bsModal
  #feedbackModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">
          <div *ngIf="!review || !review.published || showGoogleReview">{{ 'FEEDBACK' | translate }}</div>
          <div *ngIf="review && review.published && !showGoogleReview">
            {{ 'YOUR_REVIEW_OF' | translate }} {{ booking.shopName }}
          </div>
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="feedbackModal.hide()">
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="showGoogleReview">
          <h5>{{ 'HELP_OTHERS_FIND_US' | translate }}</h5>
          <span
            >{{ 'RATE_US_ON' | translate }}
            <a href="https://goo.gl/18cD5g" target="_blank">{{ 'GOOGLE' | translate }}</a></span
          >
        </div>

        <lh-review
          *ngIf="!showGoogleReview"
          [booking]="booking"
          [(ngModel)]="review"
          (done)="feedbackModal.hide()"
          #reviewComponent
        ></lh-review>
      </div>

      <div class="modal-footer">
        <div *ngIf="showGoogleReview">
          <button type="button" class="btn btn-info" (click)="setGoogleReviewDone()">
            {{ 'MAYBE_LATER' | translate }}
          </button>
          <button type="button" class="btn btn-primary" (click)="setGoogleReviewDone()">
            {{ 'DONE' | translate }}
          </button>
        </div>

        <div *ngIf="!showGoogleReview">
          <h5 class="text-left">{{ 'HELP_OTHERS_FIND_US' | translate }}</h5>
          <div>
            <table style="width: 100%">
              <tr>
                <td style="width: auto; padding: 0 4px 15px 0" (click)="onTwitterTweet()">
                  <iframe
                    src="https://platform.twitter.com/widgets/tweet_button.f7323036818f270c17ea2eebc8e6be4f.en.html#dnt=false&amp;hashtags=FreeYourselfFromLuggage&amp;id=twitter-widget-0&amp;lang=en&amp;original_referer=https%3A%2F%2Fluggagehero.com&amp;size=m&amp;text=New%20startup%20%40LuggageHero%20lets%20you%20store%20your%20luggage%20with%20local%20shops%20in%20big%20cities&amp;type=share&amp;url=https%3A%2F%2Fluggagehero.com"
                    style="position: static; visibility: visible; width: 60px; height: 20px"
                    scrolling="no"
                    frameborder="0"
                    allowtransparency="true"
                    width="auto"
                    height="35"
                    class="twitter-share-button twitter-share-button-rendered twitter-tweet-button"
                    title="Twitter Tweet Button"
                    data-url="https://luggagehero.com"
                    id="twitter-widget-0"
                  >
                  </iframe>
                </td>

                <!-- <td style="width: auto; padding: 0 4px 15px 0" (click)="onFacebookShare()">
                  <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fluggagehero.com&layout=button&size=small&mobile_iframe=true&appId=546972105509031&width=59&height=20"
                    style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" width="59" height="20">
                  </iframe>
                </td> -->

                <td style="width: 100%; padding: 0 0 0 0" (click)="onFacebookLike()">
                  <iframe
                    src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Ffacebook.com%2Fluggagehero&width=450&layout=standard&action=like&size=small&show_faces=false&share=false&height=35&appId=745703855456724"
                    style="border: none; overflow: hidden"
                    scrolling="no"
                    frameborder="0"
                    allowTransparency="true"
                    width="100%"
                    height="35"
                  >
                  </iframe>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Check out modal-->
<div
  *ngIf="booking"
  class="modal fade"
  bsModal
  #checkOutModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">
          <div *ngIf="!strategy.isFeedbackSectionVisible">
            {{ 'CHECK_OUT_EXPLANATION_1' | translate }}
            <div class="modal-subtitle">{{ 'CHECK_OUT_EXPLANATION_2' | translate }}</div>
          </div>
          <div *ngIf="strategy.isFeedbackSectionVisible">
            <div *ngIf="booking.status === 'PAID'">{{ 'BOOKING_PROGRESS_CHECKED_OUT' | translate }}</div>
            <div *ngIf="booking.status === 'CHECKED_OUT'">
              {{ 'BOOKING_PROGRESS_CHECKED_OUT' | translate }} ({{ 'PAYMENT_FAILED' | translate | lowercase }})
            </div>
          </div>
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="checkOutModal.hide()">
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <lh-shared-ui-spinner *ngIf="isLoading"></lh-shared-ui-spinner>

        <div *ngIf="booking.status === 'CHECKED_IN'">
          <!--Storage timer-->
          <div>
            <div class="storage-timer">
              <span *ngIf="storageTimerDays > 0">{{ ('0' + storageTimerDays).slice(-2) }}</span>
              <span *ngIf="storageTimerDays > 0">{{ 'STORAGE_TIMER_DAYS' | translate }}</span>
              <span>{{ ('0' + storageTimerHours).slice(-2) }}</span>
              <span>{{ 'STORAGE_TIMER_HOURS' | translate }}</span>
              <span>{{ ('0' + storageTimerMinutes).slice(-2) }}</span>
              <span>{{ 'STORAGE_TIMER_MINUTES' | translate }}</span>
              <span>{{ ('0' + storageTimerSeconds).slice(-2) }}</span>
              <span>{{ 'STORAGE_TIMER_SECONDS' | translate }}</span>
            </div>
            <label class="storage-title label-sm">{{ 'STORAGE_TIMER' | translate }}</label>
          </div>

          <button
            type="button"
            (click)="checkOutModal.hide()"
            [disabled]="isLoading"
            class="btn btn-block btn-info lh-btn btn-secondary"
          >
            {{ 'CHECK_OUT_NOT_YET' | translate }}
          </button>

          <button type="button" (click)="checkOut()" [disabled]="isLoading" class="btn btn-block btn-warning lh-btn">
            {{ 'CHECK_OUT_CONFIRMATION' | translate }}
          </button>

          <small>{{ 'STOP_STORAGE_FOOTER' | translate }}</small>
        </div>

        <lh-payment-receipt
          *ngIf="strategy.isPaymentReceiptVisible"
          [booking]="booking"
          [paymentMethod]="paymentMethod"
        ></lh-payment-receipt>

        <div *ngIf="booking.status === 'CHECKED_OUT'">
          <p>
            {{ 'RETRY_PAYMENT_EXPLANATION_PART_1' | translate }}
            <a class="href" (click)="paymentMethodModal.show()">
              {{ 'RETRY_PAYMENT_EXPLANATION_PART_2' | translate }}
            </a>
          </p>

          <button
            *ngIf="!isPaymentMethodChanged"
            (click)="paymentMethodModal.show()"
            [disabled]="isLoading"
            class="btn btn-warning btn-block"
          >
            {{ 'USE_ANOTHER_PAYMENT_CARD' | translate }}
          </button>

          <button
            (click)="checkOut()"
            [disabled]="isLoading"
            class="btn btn-block"
            [class.btn-info]="!isPaymentMethodChanged"
            [class.btn-warning]="isPaymentMethodChanged"
          >
            {{ 'RETRY_PAYMENT_BUTTON' | translate }} ({{ paymentMethod | paymentMethod: 'summary' }})
          </button>

          <small>{{ 'PAY_IN_SHOP_EXPLANATION' | translate }}</small>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Check in modal-->
<div
  *ngIf="booking"
  class="modal fade"
  bsModal
  #checkInModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">
          <div *ngIf="!strategy.isCheckOutSectionVisible">
            {{ 'CHECK_IN_EXPLANATION_1' | translate }}
            <div class="modal-subtitle">{{ 'CHECK_IN_EXPLANATION_2' | translate }}</div>
          </div>
          <div *ngIf="strategy.isCheckOutSectionVisible">{{ 'BOOKING_PROGRESS_CHECKED_IN' | translate }}</div>
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="checkInModal.hide()">
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <lh-shared-ui-spinner *ngIf="isLoading"></lh-shared-ui-spinner>

        <div *ngIf="booking.status === 'CONFIRMED'">
          <!--Storage timer-->
          <div>
            <div class="storage-timer">
              <span *ngIf="storageTimerDays > 0">{{ ('0' + storageTimerDays).slice(-2) }}</span>
              <span *ngIf="storageTimerDays > 0">{{ 'STORAGE_TIMER_DAYS' | translate }}</span>
              <span>{{ ('0' + storageTimerHours).slice(-2) }}</span>
              <span>{{ 'STORAGE_TIMER_HOURS' | translate }}</span>
              <span>{{ ('0' + storageTimerMinutes).slice(-2) }}</span>
              <span>{{ 'STORAGE_TIMER_MINUTES' | translate }}</span>
              <span>{{ ('0' + storageTimerSeconds).slice(-2) }}</span>
              <span>{{ 'STORAGE_TIMER_SECONDS' | translate }}</span>
            </div>
            <label class="storage-title label-sm">{{ 'STORAGE_TIMER' | translate }}</label>
          </div>

          <button
            type="button"
            (click)="checkInModal.hide()"
            [disabled]="isLoading"
            class="btn btn-block btn-info lh-btn btn-secondary"
          >
            {{ 'CHECK_IN_NOT_YET' | translate }}
          </button>

          <button type="button" (click)="checkIn()" [disabled]="isLoading" class="btn btn-block btn-primary lh-btn">
            {{ 'CHECK_IN_CONFIRMATION' | translate }}
          </button>
        </div>

        <div *ngIf="booking.status !== 'CONFIRMED'">
          <small>
            {{ 'YOU_CHECKED_IN_BAGS_AT_PART_1' | translate }} {{ booking.luggage.normal + booking.luggage.hand }}
            {{ (booking.luggage.normal + booking.luggage.hand === 1 ? 'BAG' : 'BAGS') | translate }}
            {{ 'YOU_CHECKED_IN_BAGS_AT_PART_2' | translate }} {{ booking.period.checkIn | lhMoment: 'localeDateTime' }}
          </small>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Payment method modal-->
<div
  *ngIf="booking"
  class="modal fade"
  [class.modal-ios]="ios"
  bsModal
  #paymentMethodModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <h4 class="modal-title pull-left">
          <div>{{ 'PAYMENT_OPTIONS' | translate }}</div>
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="paymentMethodModal.hide()">
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            <path d="M0 0h24v24H0z" fill="none"/>
          </svg>
        </button>
      </div> -->

      <div class="modal-body">
        <lh-payment-options
          *ngIf="strategy.isPaymentOptionsVisible"
          [(ngModel)]="paymentMethod"
          [booking]="booking"
          [paymentMethods]="paymentMethods"
          [isPaymentDue]="strategy.isPaymentDue"
          [isLegacyMode]="true"
        >
        </lh-payment-options>
        <div *ngIf="!strategy.isPaymentOptionsVisible">{{ paymentMethod | paymentMethod }}</div>
      </div>

      <div class="modal-footer" *ngIf="!strategy.isPaymentInfoDue || strategy.isPaymentMethodSectionCompleted">
        <table width="100%">
          <tr>
            <td class="text-left" *ngIf="booking.paymentMethodId">
              <!-- <table class="table"><tr><td class="checkmark">✔</td><td><small>{{ 'PAYMENT_METHOD_READY' | translate }}</small></td></tr></table> -->
            </td>
            <td>
              <button class="btn btn-primary" (click)="paymentMethodModal.hide()" [disabled]="!booking.paymentMethodId">
                {{ 'DONE' | translate }}
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>

<!--Reservation modal-->
<div
  *ngIf="booking"
  class="modal fade"
  bsModal
  #reservationModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fullscreen-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ 'BOOKING_PROGRESS_CONFIRMED' | translate }}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="reservationModal.hide()">
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <lh-booking-info [booking]="booking" [shop]="shop"></lh-booking-info>
      </div>
    </div>
  </div>
</div>

<!--Tutorial modal-->
<div
  class="modal fade"
  bsModal
  #tutorialModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="tutorialModal.hide()">
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
        <h4 class="modal-title">{{ 'BOOKING_CONFIRMED' | translate }}</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <strong>{{ 'READY_TO_GO' | translate }}</strong> {{ 'ADDRESS_SENT' | translate }}
        </div>
        <br />
        <div class="text-center">
          <img src="../../../../assets/check-in-finger-no-text.png" width="50%" />
        </div>
        <div class="form-group text-center">{{ 'REMEMBER_TO_CHECK_IN' | translate }}</div>

        <button type="button" (click)="tutorialModal.hide()" class="btn btn-link ok-btn btn-lg btn-block">
          {{ 'OK_GOT_IT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!--Directions modal-->
<div
  class="modal fade"
  bsModal
  #directionsModal="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div *ngIf="booking" class="modal-dialog modal-fullscreen-sm">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="directionsModal.hide()">
          <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
        <h4 class="modal-title">{{ 'FIND_SHOP' | translate }}</h4>
      </div>

      <div class="modal-body">
        <a
          type="button"
          class="href"
          [href]="shop | mapsLink: true"
          target="_blank"
          angulartics2On="click"
          angularticsAction="ViewGoogleMapsBooking"
          [angularticsCategory]="booking.address.countryCode"
          [angularticsLabel]="booking.shopName"
        >
          <lh-image-slide
            [ctaText]="'GET_DIRECTIONS' | translate"
            [headerText]="booking.shopName"
            [imageUrl]="imageUrl"
            [blurImages]="false"
            [showWatermark]="true"
          >
          </lh-image-slide>
        </a>

        <!-- <h5>{{ booking.shopName }}</h5> -->
        <div class="address">
          <strong>{{ 'ADDRESS' | translate }}:</strong>
          <span *ngIf="booking.address.countryCode !== 'dk'"
            >{{ booking.address.street }}, {{ booking.address.city }} {{ booking.address.postal }}</span
          >
          <span *ngIf="booking.address.countryCode === 'dk'"
            >{{ booking.address.street }}, {{ booking.address.postal }} {{ booking.address.city }}</span
          >
        </div>

        <small *ngIf="showSimpleOpeningHours">
          <div>
            <span
              >{{ booking.period.from | lhMoment: 'calendar' }} {{ 'OPEN' | translate }}
              {{ getOpeningHoursFromDate(booking.period.from, shop) | timeInterval | async }}</span
            >
            <a class="href" (click)="toggleFullOpeningHours()">{{ 'MORE' | translate }}</a>
          </div>

          <div *ngIf="isNotSameDay(booking.period.from, booking.period.to)" class="shop-details-hours">
            <span
              >{{ booking.period.to | lhMoment: 'calendar' }}
              {{ getOpeningHoursFromDate(booking.period.to, shop) | timeInterval | async }}</span
            >
          </div>
        </small>

        <small *ngIf="showFullOpeningHours">
          <table class="table lh-time-table">
            <tr>
              <td>{{ 'MONDAY' | translate }}</td>
              <td>{{ shop.openingHours.monday | timeInterval | async }}</td>
            </tr>
            <tr>
              <td>{{ 'TUESDAY' | translate }}</td>
              <td>{{ shop.openingHours.tuesday | timeInterval | async }}</td>
            </tr>
            <tr>
              <td>{{ 'WEDNESDAY' | translate }}</td>
              <td>{{ shop.openingHours.wednesday | timeInterval | async }}</td>
            </tr>
            <tr>
              <td>{{ 'THURSDAY' | translate }}</td>
              <td>{{ shop.openingHours.thursday | timeInterval | async }}</td>
            </tr>
            <tr>
              <td>{{ 'FRIDAY' | translate }}</td>
              <td>{{ shop.openingHours.friday | timeInterval | async }}</td>
            </tr>
            <tr>
              <td>{{ 'SATURDAY' | translate }}</td>
              <td>{{ shop.openingHours.saturday | timeInterval | async }}</td>
            </tr>
            <tr>
              <td>{{ 'SUNDAY' | translate }}</td>
              <td>{{ shop.openingHours.sunday | timeInterval | async }}</td>
            </tr>
          </table>

          <a class="href" (click)="toggleFullOpeningHours()">{{ 'SHOW_LESS' | translate }}</a>
        </small>
      </div>

      <div class="modal-footer">
        <a
          type="button"
          class="btn btn-link btn-block"
          width="50%"
          [href]="shop | mapsLink"
          target="_blank"
          angulartics2On="click"
          angularticsAction="ViewGoogleMapsBooking"
          [angularticsCategory]="booking.address.countryCode"
          [angularticsLabel]="booking.shopName"
        >
          {{ 'VIEW_IN_MAPS' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
